import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { config } from '../../../../config';
import { Client } from '../clients';
import { User } from './user.model';

interface UserResponse {
  data: User;
}

interface ClientResponse {
  data: Client[];
}

@Injectable()
export class UserService {
  constructor(
    private http: HttpClient) {}

  get(query: string = '') {
    return this.http
      .get<any>(`${config.apiLocation}/v1/users?${query}`);
  }

  getById(id: string): Observable<User> {
    return this.http
      .get<UserResponse>(`${config.apiLocation}/v1/users/${id}`)
      .map(res => res.data);
  }

  register(user: RecursivePartial<User>, client: RecursivePartial<Client>): Observable<any> {
    return this.http
      .post<{ data: any }>(`${config.apiLocation}/auth/register`, { user, client });
  }

  createAdmin(user: RecursivePartial<User>): Observable<User> {
    return this.http
    .post<UserResponse>(`${config.apiLocation}/v1/admin/users`, user)
    .map(res => res.data);
  }

  update(id: string, user: RecursivePartial<User>): Observable<User> {
    return this.http
      .patch<UserResponse>(`${config.apiLocation}/v1/users/${id}`, user)
      .map(res => res.data);
  }

  delete(id: string): Observable<ClientResponse | void> {
    return this.http.delete<ClientResponse | void>(`${config.apiLocation}/v1/users/` + id);
  }

  restore(id: string): Observable<void> {
    return this.http.patch<void>(`${config.apiLocation}/v1/users/${id}/restore`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/users/user.service.ts